import React, { useEffect, useRef, useState } from 'react'
import './index.scss'
import { data } from '../../data/PodcastData'
import { background } from 'assets/backgrounds'
import { useParams } from 'react-router-dom'
import { usePodcastsTemplate } from 'common/hooks/usePodcastTemplate'
import { SpotifyIcon } from 'pages/episode/components/SpotifyIcon'
import { Link } from 'react-router-dom'

// Custom Tag component
const Tag = ({ children, color }) => (
  <div className={`p-3 text-sm rounded-full text-[#020251] ${color}`}>
    {children}
  </div>
)

// Custom Avatar component
const Avatar = ({ src, alt }) => (
  <div className='w-12 h-12 rounded-full overflow-hidden'>
    <img src={src} alt={alt} className='w-full h-full object-cover' />
  </div>
)

// Custom Badge component
const Badge = ({ children, variant = 'blue' }) => (
  <span className='px-2 py-0.5 text-xs rounded-full bg-blue-50 text-blue-700'>
    {children}
  </span>
)

const Episode = () => {
  const { id } = useParams()

  const { episode, loadEpisode } = usePodcastsTemplate()
  useEffect(loadEpisode(id), [loadEpisode])
  const sliderRef = useRef<any>(null)
  const next = () => {
    sliderRef.current.slickNext()
  }
  const previous = () => {
    sliderRef.current.slickPrev()
  }
  const [filterData, setFilterData] = useState<any>(data)
  const [episodeToShow, setEpisodeToShow] = useState(4)

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  }

  const handleShowMore = () => {
    let newRecord = 0
    if (episodeToShow < filterData.length) {
      newRecord = episodeToShow + 4
    } else {
      newRecord = episodeToShow - 4
    }
    console.log(newRecord)
    setEpisodeToShow(newRecord)
  }

  return (
    <section>
      <div className='p-[240px_160px] mt-[-100px] bg-[#9ABDEC] '>
        <div className='grid md:grid-cols-[auto_650px] md:gap-[80px]'>
          <div>
            <h1 className='text-[#020251] md:text-[64px] font-bold '>
              About this podcast
            </h1>
            <p className='text-justify md:text-[16px] text-[#101828] mt-[24px] '>
              {episode?.description}
            </p>
          </div>
          <img src={background.Episode.Hero} alt='' />
        </div>
      </div>
      <div className='md:w-[1500px] mx-auto mt-[-200px] bg-white md:p-[40px] md:rounded-[20px] md:space-y-[40px] '>
        <h1 className='text-[#020251] text-center md:text-[40px] font-bold '>
          {episode?.title}
        </h1>
        {/* Tags and Time Row */}
        <div className='flex flex-wrap gap-2 justify-between items-center mb-4'>
          <div className='flex justify-between items-center gap-2'>
            {episode?.tags?.map((tag, idx) => (
              <div
                className={`badge ${idx / 2 ? 'bg-[#EBF3FF]' : 'bg-[#D2F6FF]'}`}
              >
                {tag}
              </div>
            ))}
          </div>
          <div className='ml-auto flex items-center gap-3'>
            <span className='text-sm text-gray-600'>1 hr, 24 min</span>
            <div className='h-1 w-48 bg-gray-200 rounded-full'>
              <div className='h-1 w-1/3 bg-blue-600 rounded-full'></div>
            </div>

            <div className='flex items-center gap-4'>
              <div className='w-[1px] h-[40px] bg-[#D8D8DF]' />
              {/* <HeartIcon isLiked={true} />
                <ShareIcon />
                <PlayIcon /> */}
            </div>
          </div>
          {/* Listen Via */}
          <div className='ml-auto flex flex-col justify-center items-center gap-2'>
            <span className='text-sm text-gray-600'>Listen via:</span>
            <div className='flex justify-between items-center gap-2'>
              <Link to={episode?.url}>
                <SpotifyIcon />
              </Link>
              {/*                <GooglePodcastIcon />
                <ApplePodcastIcon /> */}
            </div>
          </div>
        </div>

        {/* Host Section */}
        <div className='mb-8 p-4 border-2 rounded-[8px] border-[#BBC7D7] border-solid'>
          <div className='flex items-start gap-4 mb-4'>
            <Avatar
              src={episode?.publisher?.avatar}
              alt={episode?.publisher?.name}
            />
            <div>
              <div className='flex items-center justify-between gap-2 mb-1'>
                <h2 className='font-semibold'>{episode?.publisher?.name}</h2>
                <div className=''>Host</div>
              </div>
              <p className='text-sm text-gray-600'>
                {episode?.publisher?.author_type}
              </p>
            </div>
          </div>
          <p className='text-gray-600 text-sm leading-relaxed'>
            {episode?.publisher?.bio}
          </p>
        </div>

        {/* Guest Section */}
        <div className='mb-8 p-4 border-2 rounded-[8px] border-[#BBC7D7] border-solid'>
          {episode?.speakers?.map((speaker) => (
            <div className='flex items-start gap-4 mb-4'>
              <Avatar src={speaker.avatar} alt={speaker.name} />
              <div>
                <div className='flex items-center gap-2 mb-1'>
                  <h2 className='font-semibold'>{speaker.name}</h2>
                  <Badge>Guest</Badge>
                </div>
                <p className='text-sm text-gray-600'>
                  {speaker.type}
                  {speaker.linkedin_url && (
                    <a
                      href={speaker.linkedin_url}
                      className='text-blue-600 hover:underline'
                    >
                      Linkedin
                    </a>
                  )}
                </p>
              </div>
            </div>
          ))}
          <p className='text-gray-600 text-sm leading-relaxed'>
            {episode?.publisher?.bio || 'No bio'}
          </p>

          {/* Footer */}
          <div className='flex flex-wrap justify-between items-center pt-4 border-t border-gray-200'>
            <button className='flex items-center gap-2 text-[#001A3D] hover:underline'>
              <svg
                className='w-4 h-4'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
              >
                <path
                  d='M7 10L12 15L17 10'
                  strokeWidth='2'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
              Download podcast transcript
            </button>
            <span className='text-sm text-[#37A2BA]'>
              Published on{' '}
              {new Date(episode.publish_date).toLocaleDateString('en-GB')}
            </span>
          </div>
        </div>
      </div>
      <div className='max-w-8xl mt-44 mx-auto px-24'>
        <div className='flex items-center justify-between w-full'>
          <h1 className='text-2xl font-bold mb-6'>Podcast Content</h1>
          <button className='flex items-center gap-2 bg-gray-200 text-gray-800 px-4 py-2 rounded-md mb-6 text-sm appearance-none bg-transparent'>
            <svg
              className='w-4 h-4'
              viewBox='0 0 24 24'
              fill='none'
              stroke='currentColor'
            >
              <path
                d='M7 10L12 15L17 10'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
            Download podcast transcript
          </button>
        </div>
        <div className='space-y-6 text-gray-700 leading-relaxed'>
          <div dangerouslySetInnerHTML={{ __html: episode.content }} />
        </div>
      </div>
    </section>
  )
}

export default Episode
